import { Close } from "@mui/icons-material";
import { FETCH_ENCOUNTER_FROM_ID } from "adapters/ehr.service";
const { IconButton } = require("@mui/material");
const { useSelector } = require("react-redux");
const { useDispatch } = require("react-redux");
const { set_show_popup } = require("redux/actions/ScribeAcitons");

const IframeCloseButton = (props) => {
  const reduxDispatch = useDispatch();
  const isRecording = useSelector((state) => state?.recognizer?.recording);
  const iframeScreenType = useSelector(
    (state) => state?.app?.iframe_screen_type,
  );
  const encounterObj = useSelector((state) => state?.encounterObj);

  if (iframeScreenType === "external") return <></>;

  return (
    <>
      <IconButton
        style={{ position: "fixed", top: "8px", left: "18px" }}
        edge="start"
        color="primary"
        aria-label="close"
        onClick={async () => {
          const encounterResource = await FETCH_ENCOUNTER_FROM_ID(
            encounterObj?.encounter?.id,
          );
          const encounter = encounterResource?.entry?.[0]?.resource;

          // Extract external encounter ID from the identifier array
          const encounter_id = encounter?.identifier?.find((item) =>
            item?.system?.endsWith("external-id"),
          )?.value;
          if (isRecording) {
            reduxDispatch(
              set_show_popup(true, () => {
                window?.parent?.postMessage(
                  {
                    type: "scribe.window.close",
                    timestamp: new Date().toISOString(),
                    payload: {
                      encounterId: encounter_id,
                    },
                  },
                  "*",
                );
              }),
            );
          } else {
            window?.parent?.postMessage(
              {
                type: "scribe.window.close",
                timestamp: new Date().toISOString(),
                payload: {
                  encounterId: encounter_id,
                },
              },
              "*",
            );
          }
        }}
      >
        <Close />
      </IconButton>
    </>
  );
};

export default IframeCloseButton;
